require('../../modules/es.string.pad-end');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'padEnd');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/string/pad-end.js
// module id = 1230
// module chunks = 1